"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _parseFloat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/number/parse-float"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./RatingDisplay.scss");
var _fullStar = _interopRequireDefault(require("./assets/full-star"));
var _percentageStar = _interopRequireDefault(require("./assets/percentage-star"));
var _emptyStar = _interopRequireDefault(require("./assets/empty-star"));
var RatingDisplay = function RatingDisplay(_ref) {
  var _context2, _context3, _context4, _context5;
  var rating = _ref.rating,
    customId = _ref.customId,
    customClass = _ref.customClass,
    starSize = _ref.starSize,
    emptyStarColor = _ref.emptyStarColor,
    ratingFontSize = _ref.ratingFontSize,
    reviewsFontSize = _ref.reviewsFontSize,
    reviewCount = _ref.reviewCount,
    reviewCountLink = _ref.reviewCountLink,
    reviewCountLocation = _ref.reviewCountLocation,
    reviewCountNumberOnly = _ref.reviewCountNumberOnly,
    ratingLocation = _ref.ratingLocation;
  var normalizedRating;
  var displayRating;
  if (rating) {
    if (rating > 5.0) {
      normalizedRating = 5.0;
    } else if (rating < 0) {
      normalizedRating = 0.0;
    } else {
      normalizedRating = (0, _parseFloat["default"])(rating.toFixed(1));
    }
    displayRating = normalizedRating.toFixed(1);
  } else {
    normalizedRating = 0.0;
    displayRating = 'No reviews yet.';
  }
  var baseStars = Math.floor(normalizedRating);
  var starOverflow = normalizedRating - baseStars;
  var greyStars = 5 - Math.ceil(normalizedRating);
  var ratingLocationInternal = ratingLocation || 'right';
  var starSizeInternal = starSize || '2em';
  var emptyStarColorInternal = emptyStarColor || '#EAEAEA';
  var reviewCountLocationInternal = reviewCountLocation === 'right' ? 'inline' : 'block';
  var naRating = displayRating === 'No reviews yet.' ? 'rating-number na-rating' : 'rating-number';
  var reviewCountDisplay;
  if (reviewCountLink) {
    reviewCountDisplay = /*#__PURE__*/_react["default"].createElement("p", {
      className: "review-count",
      style: {
        display: reviewCountLocationInternal,
        fontSize: reviewsFontSize
      }
    }, reviewCountLink);
  } else {
    var _context;
    reviewCountDisplay = /*#__PURE__*/_react["default"].createElement("p", {
      className: "review-count",
      style: {
        display: reviewCountLocationInternal,
        fontSize: reviewsFontSize
      }
    }, (0, _concat["default"])(_context = "(".concat(reviewCount, ") ")).call(_context, reviewCountNumberOnly ? '' : 'Verified Reviews'));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: customId,
    className: customClass,
    "aria-label": "rating-number-".concat(customId)
  }, ratingLocationInternal === 'top' ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "rating-number",
    style: {
      fontSize: ratingFontSize
    }
  }, displayRating) : null, /*#__PURE__*/_react["default"].createElement("div", {
    id: "Rating-Display-Wrapper",
    className: "star-ratings",
    "aria-label": "rating star"
  }, ratingLocationInternal === 'left' ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "rating-number",
    style: {
      fontSize: ratingFontSize
    }
  }, displayRating) : null, (0, _map["default"])(_context2 = (0, _toConsumableArray2["default"])((0, _keys["default"])(_context3 = Array(baseStars)).call(_context3))).call(_context2, function (n) {
    return /*#__PURE__*/_react["default"].createElement(_fullStar["default"], {
      size: starSizeInternal,
      key: "full-star-".concat(n)
    });
  }), starOverflow > 0 ? /*#__PURE__*/_react["default"].createElement(_percentageStar["default"], {
    widthPercentage: starOverflow,
    size: starSizeInternal,
    unfilledColor: emptyStarColorInternal
  }) : null, (0, _map["default"])(_context4 = (0, _toConsumableArray2["default"])((0, _keys["default"])(_context5 = Array(greyStars)).call(_context5))).call(_context4, function (n) {
    return /*#__PURE__*/_react["default"].createElement(_emptyStar["default"], {
      key: "empty-star-".concat(n),
      size: starSizeInternal,
      unfilledColor: emptyStarColorInternal
    });
  }), /*#__PURE__*/_react["default"].createElement("span", null, ratingLocationInternal !== 'top' && ratingLocationInternal !== 'left' ? /*#__PURE__*/_react["default"].createElement("span", {
    className: naRating,
    style: {
      fontSize: ratingFontSize
    }
  }, displayRating) : null, reviewCount ? reviewCountDisplay : null)));
};
RatingDisplay.propTypes = {
  rating: _propTypes["default"].number,
  customId: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  starSize: _propTypes["default"].string,
  emptyStarColor: _propTypes["default"].string,
  ratingFontSize: _propTypes["default"].string,
  reviewsFontSize: _propTypes["default"].string,
  reviewCount: _propTypes["default"].number,
  reviewCountLink: _propTypes["default"].node,
  reviewCountLocation: _propTypes["default"].string,
  reviewCountNumberOnly: _propTypes["default"].bool,
  ratingLocation: _propTypes["default"].string
};
RatingDisplay.defaultProps = {
  rating: undefined,
  customId: '',
  customClass: '',
  starSize: '2em',
  emptyStarColor: '#EAEAEA',
  ratingFontSize: '1.2em',
  reviewsFontSize: '1.2em',
  reviewCount: undefined,
  reviewCountLink: undefined,
  reviewCountLocation: 'right',
  reviewCountNumberOnly: false,
  ratingLocation: 'right'
};
var _default = exports["default"] = RatingDisplay;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/RatingDisplay.js
// module id = 329
// module chunks = 25